<script setup lang="ts">
import logoInternetMuseum from '@/assets/images/logo-internet-museum-horizontal.svg'
import logoMucolle from '@/assets/images/logo-mucolle.png'
import logoMuseumAction from '@/assets/images/logo-museum-action.png'

const images = {
  logoInternetMuseum,
  logoMucolle,
  logoMuseumAction,
}
const date1 = useDayjs()
const storeIndex = useStoreIndex()
</script>

<template>
  <div
    class="c-footer"
  >
    <!--    Social panel -->
    <div
      class="c-socialPanel"
    >
      <div class="c-socialPanel_content">
        <div
          class="c-socialPanel_content_row"
        >
          <div class="c-socialPanel_content_row_col">
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/event"
            >
              展覧会
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/museum"
            >
              美術館・博物館
            </NuxtLink>
          </div>

          <div class="c-socialPanel_content_row_col">
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/report"
            >
              レポート
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/special"
            >
              特集
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/news"
            >
              ニュース
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/present"
            >
              プレゼント
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/gakugeiin"
            >
              学芸員募集
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/imbbs"
            >
              掲示板
            </NuxtLink>
          </div>

          <div class="c-socialPanel_content_row_col">
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/jyunkai"
            >
              巡回展
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/schedule"
            >
              {{ storeIndex.state.displayYear }}年の展覧会スケジュール
            </NuxtLink>
          </div>

          <div class="c-socialPanel_content_row_col">
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/tv-museum"
            >
              テレビでミュージアム
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/royal-family"
            >
              皇室がご覧になった展覧会
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/naruhodo"
            >
              なるほどミュージアム
            </NuxtLink>
          </div>

          <div class="c-socialPanel_content_row_col">
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/login"
            >
              ログイン
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/signup"
            >
              新規登録
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/mypage/foryou/event"
            >
              For You
            </NuxtLink>
          </div>

          <div class="c-socialPanel_content_row_col">
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/static/about"
            >
              このサイトについて
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/static/information"
            >
              情報の登録について
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/static/aboutAd"
            >
              広告について
            </NuxtLink>
            <NuxtLink
              class="c-socialPanel_content_row_col_item"
              to="/static/about#contact"
            >
              お問い合わせ
            </NuxtLink>
          </div>

          <v-spacer />

          <div class="c-socialNavi_03 l-blank-icon-none">
            <a
              class="c-socialNavi_03_item"
              href="https://www.youtube.com/c/InternetMuseum_official"
              target="_blank"
              rel="noopener"
            >
              <i class="c-socialNavi_03_item_youtube" />
            </a>
            <a
              class="c-socialNavi_03_item"
              href="https://twitter.com/InternetMuseum"
              target="_blank"
              rel="noopener"
            >
              <i class="c-socialNavi_03_item_x" />
            </a>
            <a
              class="c-socialNavi_03_item"
              href="https://www.facebook.com/internetmuseum"
              target="_blank"
              rel="noopener"
            >
              <i class="c-socialNavi_03_item_fb" />
            </a>
            <a
              class="c-socialNavi_03_item"
              href="https://www.instagram.com/internetmuseum_official/"
              target="_blank"
              rel="noopener"
            >
              <i class="c-socialNavi_03_item_ins" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--    Divider -->
    <v-divider />
    <!--    About panel -->
    <div
      class="c-aboutPanel"
    >
      <div
        class="c-aboutPanel_content"
      >
        <!--        Left column -->
        <div>
          <v-card
            flat
            tile
          >
            <CommonImage
              class="c-aboutPanel_content_imgLogo"
              v-bind:src="images.logoInternetMuseum"
              position="center left"
              object-fit="contain"
              width=""
              height="45px"
            />
            <v-card-text class="c-aboutPanel_content_text">
              美術館・博物館・展覧会<br class="sp-only">アイエム［インターネットミュージアム］<br><br>丹青社グループが運営しています<br><br>編集・制作／ (株)丹青社
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
    <!--      Copyright panel -->
    <div
      class="c-copyrightPanel"
    >
      <div
        class="c-copyrightPanel_content"
      >
        <div class="c-copyrightPanel_content_text">
          Copyright(C)1996-{{ date1.year() }} Internet Museum Office. All Rights Reserved
        </div>
        <v-spacer class="pc-only" />
        <v-spacer class="pc-only" />
        <v-spacer class="pc-only" />
        <v-spacer class="pc-only" />
        <div class="c-copyrightPanel_content_label">
          <NuxtLink
            class="c-socialPanel_content_row_col_item"
            to="/term"
          >
            利用規約
          </NuxtLink>
        </div>
        <v-spacer class="pc-only" />
        <div class="c-copyrightPanel_content_label">
          <NuxtLink
            class="c-socialPanel_content_row_col_item"
            to="/static/privacy"
          >
            個人情報の取り扱いについて
          </NuxtLink>
        </div>
      </div>
    </div>

    <a href="#">
      <img
        src="@/assets/images/button-totop.png"
        class="button-totop"
      >
    </a>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-footer {
  width: 100%;
  min-width: var(--g_min_screen_width_pc);

  @include responsive.mq_down(sp) {
    min-width: auto;
  }
}

.c-socialPanel {
  width: 100%;
  background-color: var(--color_primary);

  a {
    color: #fff;
  }

  @include responsive.mq_up(pc) {
    display: flex;
    justify-content: center;
    height: 310px;
  }

  @include responsive.mq_down(sp) {
    position: relative;
    padding: 30px 30px 54px;
    color: var(--g_color_button_text_white);
    font-size: 14px;

    @include responsive.mq_down(sp) {
      padding: 30px 15px 54px;
    }

    .c-socialNavi_01 {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;

      &_item {
        box-sizing: border-box;
        flex: 0 0 50%;
        max-width: 50%;
        margin-top: 10px;
        text-align: left;

        &:nth-of-type(-n + 2) {
          margin-bottom: 20px;
        }

        &:nth-of-type(odd) {
          flex: 0 0 40%;
          max-width: 40%;
        }
      }
    }

    .c-socialNavi_02 {
      margin-bottom: 20px;

      &_item {
        margin-top: 10px;
        text-align: left;
      }
    }
  }

  &_col {
    @include responsive.mq_up(pc) {
      margin-left: 20px;
    }

    @include responsive.mq_down(sp) {
      position: absolute;
      bottom: 30px;

      &:last-child {
        left: 78px;
      }
    }

    &_button {
      &:hover {
        text-decoration: none;
      }

      @include responsive.mq_up(pc) {
        transition: 300ms;

        &:hover {
          opacity: 0.75;
        }
      }

      &_icon {
        color: var(--g_color_button_text_white) !important;
      }
    }
  }

  &_content {
    width: 100%;
    max-width: var(--g_max_content_width);
    height: 100%;

    @include responsive.mq_up(pc) {
      margin-top: 30px;
      padding: 0 4px;
    }

    &_row {
      width: 100%;

      @include responsive.mq_up(pc) {
        display: flex;
        margin-top: 20px;
        color: var(--g_color_text_white);
        line-height: 1.714;

        &_moveWeb {
          margin-top: 5px;
          margin-right: 30px;
          transition: 300ms;
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 14px;
          font-weight: 400;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &_col {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-right: 3.7%;
        margin-bottom: 10px;

        @include responsive.mq_down(sp) {
          flex-direction: row;
          flex-wrap: wrap;
          width: 100%;
          margin-bottom: 15px;
        }

        &_item {
          transition: 300ms;
          font-size: 14px;
          font-weight: 400;

          @include responsive.mq_up(pc) {
            margin-bottom: 15px;
            font-family: var(--g_font_family_NotoSansCJKjp);

            &:hover {
              text-decoration: underline;
            }
          }

          @include responsive.mq_down(sp) {
            width: 50%;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}

.c-aboutPanel {
  background-color: var(--g_color_background_white);

  @include responsive.mq_up(pc) {
    display: flex;
    justify-content: center;
    height: 220px;
  }

  &_content {
    @include responsive.mq_up(pc) {
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: var(--g_max_content_width);
      margin-top: 40px;
      padding: 0 4px;

      &_imgLogo {
        width: 276px;
        height: 45px;
      }

      &_text {
        margin-top: 20px;
        padding: 0;
        color: var(--g_color_button_text_black) !important;
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 12px;
        font-weight: 500;
        line-height: 1.667;
      }

      .c-bannerContent {
        a {
          display: block;
          transition: 0.2s opacity ease;

          &:hover {
            opacity: 0.75;
          }
        }
      }

      &_imgBanner {
        width: 235px;
        height: 64px;
      }

      &_imgSubBanner {
        width: 235px;
        height: 64px;
        margin-top: 10px;
      }
    }

    @include responsive.mq_down(sp) {
      padding: 25px 15px;

      &_imgLogo {
        width: 226px;
        height: 25px;
      }

      &_text {
        width: 101%;
        margin-top: 15px;
        padding: 0;
        color: var(--color_text_base) !important;
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 12px;
        font-weight: 500;
        line-height: 1.667;
      }

      .c-bannerContent {
        @include responsive.mq_down(sp) {
          display: flex;
          justify-content: center;
        }

        .v-card {
          display: flex;
          margin-top: 40px;
          margin-left: -15px;

          @include responsive.mq_down(sp) {
            justify-content: center;
            margin-left: 0;
          }
        }

        &_item {
          flex: 0 0 165px;
          flex-basis: 165px;
          width: 165px;
          height: 45px;
          margin-left: 15px;

          @include responsive.mq_down(sp) {
            margin-right: 7px;
            margin-left: 7px;
          }

          @include responsive.mq_down(small) {
            flex: 0 0 140px;
            flex-basis: 140px;
            width: 140px;
            height: 38px;
          }
        }
      }
    }
  }
}

.c-copyrightPanel {
  background-color: var(--color_background_whiteblue);

  a {
    color: var(--color_text_base);
  }

  @include responsive.mq_up(pc) {
    display: flex;
    justify-content: center;
    height: 80px;
  }

  @include responsive.mq_down(sp) {
    padding: 30px 15px;
  }

  &_content {
    display: flex;

    @include responsive.mq_up(pc) {
      align-items: center;
      justify-content: space-between;
      width: 100%;
      max-width: var(--g_max_content_width);
    }

    @include responsive.mq_down(sp) {
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    &_text {
      color: #898989;
      font-family: var(--g_font_family_Merriweather);

      @include responsive.mq_up(pc) {
        font-size: 12px !important;
      }

      @include responsive.mq_down(sp) {
        width: 100%;
        margin-bottom: 20px;
        font-size: 10px;
      }
    }

    &_label {
      color: var(--g_color_button_text_black);

      @include responsive.mq_up(pc) {
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 14px;
        font-weight: 500;
        line-height: 1.714;
      }

      @include responsive.mq_down(sp) {
        font-size: 10px;

        &:last-child {
          margin-left: 50px;
        }
      }
    }
  }
}

.pc-only {
  display: block !important;

  @include responsive.mq_down(sp) {
    display: none !important;
  }
}

.sp-only {
  display: none !important;
  width: 100%;

  @include responsive.mq_down(sp) {
    display: block !important;
  }
}

.button-totop {
  position: fixed;
  z-index: 4;
  right: 30px;
  bottom: 110px;
  width: 40px;
  height: 40px;

  @include responsive.mq_down(sp) {
    display: none;
  }
}

.c-socialNavi_03 {
  display: flex;
  margin-top: 200px;

  @include responsive.mq_down(sp) {
    margin-top: 24px;
  }

  &_item {
    margin: 0 8px;

    &:hover {
      opacity: 0.7;
    }

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }

    i {
      display: inline-block;
    }

    &_youtube {
      width: 24px;
      height: 24px;
      background: url("@/assets/images/icon-youtube-footer.png") no-repeat;
    }

    &_x {
      width: 22px;
      height: 22px;
      background: url("@/assets/images/icon-x-footer.png") no-repeat;
    }

    &_fb {
      width: 24px;
      height: 24px;
      background: url("@/assets/images/icon-facebook-footer.png") no-repeat;
    }

    &_ins {
      width: 24px;
      height: 24px;
      background: url("@/assets/images/icon-ins-footer.png") no-repeat;
    }
  }
}
</style>
